import Header from '../components/Header'
import SearchBar from '../components/search/SearchBar'
import Footer from '../components/Footer'
import ReleaseDetails from '../components/ReleaseDetails'

export default function ReleasePage () {
  return (
    <>
      <Header/>
      <SearchBar/>
      <ReleaseDetails/>
      <Footer absolute={false}/>
    </>
  )
}